import React, {Fragment} from "react";
import {styled} from '@mui/material/styles';
import _ from "lodash";

import {BgImage} from "gbimage-bridge"
import {getImage} from "gatsby-plugin-image"

import {Link} from "gatsby"

import {getEntityUrl, getOverlayImages} from "../../util";
import Wrapper from "../../components/Wrapper";

//polyfill for old Androids; TODO - move away from here
import "core-js/proposals/string-match-all";

import {useAllFiles} from "../../hooks/all-files";
import Menu from "../../components/AltMenu";

const PREFIX = 'EntityPage';

const classes = {
    bildbutton: `${PREFIX}-bildbutton`,
    bHeadline: `${PREFIX}-bHeadline`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.bildbutton}`]: {
        display: 'block',
        position: 'absolute',
        /* font-family: 'openlight', */
        bottom: '12px',
        left: '10px',
        whiteSpace: 'nowrap',
        padding: '8px 15px',
        background: 'rgba(86, 86, 86, 0.3)',
        fontSize: 'var(--font-size-large)',
        color: '#ffffff !important',
        border: '1px solid #FFF',
        letterSpacing: '0.06em',
        textDecoration: 'none!important',
        textTransform: 'uppercase',
        /* Custom 1 */
        //  boxShadow: '0 0 0 7px rgba(183, 183, 183, 0.5), 0 0 0 21px rgba(201, 201, 201, 0.3), 0 0 0 63px rgba(211, 211, 211, 0.2), 0 0 0 186px rgba(201, 201, 201, 0.1), 0 0 0 558px rgba(190, 190, 190, 0.1)',
        // borderRadius: '50%',
        // padding: '7px 55px 7px 55px',
        /* End Custom 1 */
    },

    [`& .${classes.bHeadline}`]: {
        position: 'absolute',
        bottom: '62px',
        left: '11px',
        /* webkitTransform: 'translateX(-50%)', */
        /* transform: 'translateX(-50%)', */
        /*whiteSpace: 'nowrap',*/
        width: 'fit-content',
        margin: '0',
        /* text-align: 'center', */
        fontSize: 'var(--font-size-larger)',
        color: '#ffffff !important',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textShadow: '2px 2px 3px hsl(0deg 0% 0% / 48%)',
        fontFamily: 'opensans',
        letterSpacing: '0',
        lineHeight: '1.1',
    }
}));

const EntityPageItem = ({item, isFirst, files, defaultLocale}) => {
    const childImg = getImage(item.smallImage?.localFile);

    const listRole = _.find(item.Roles, {strapi_component: 'role.list-child'});
    const overlays = getOverlayImages(listRole, files);

    const title1 = listRole?.line1 || item.title || '';
    const title2 = listRole?.line2 || false;

    const url = getEntityUrl({entity: item, defaultLocale});

    return <Link to={url}>
        <BgImage
            preserveStackingContext={true}
            image={childImg}
            style={{
                height: isFirst ? "61vh" : "37vh",
                backgroundSize: "cover",
                backgroundPosition: "95% top",
                borderBottom: "1px solid #fff"
            }}>
            {overlays?.map(o => {
                return <Fragment key={`overlay-${item.id}`}>{o}</Fragment>
            })}
            {title2 !== false && <div className={classes.bHeadline}>{title2}</div>}
            <div className={classes.bildbutton}>{title1}</div>
        </BgImage>
    </Link>
}

const EntityPage = (props) => {

    const {entity, pageContext} = props;
    const {strapiChildren: children} = entity;
    const files = useAllFiles();
    const {defaultLocale} = pageContext;

    return <Root className="renoir imagelist">
        <Wrapper {...props} menu={Menu} topbar={false} title={entity.title}>
            <div>
                {children.filter((child) => child.smallImage).map((child, n) =>
                    <Fragment key={`${child.id}`}>
                            <EntityPageItem item={child} isFirst={n === 0} files={files} defaultLocale={defaultLocale}/>
                    </Fragment>
                )}
            </div>
        </Wrapper>
    </Root>
}

export default EntityPage;
